import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { format } from 'date-fns';
import {useParams } from "react-router";
import { useStore } from "../../../app/stores/store";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import { transform } from "typescript";
import { CCTMovimiento } from "../../../app/models/CCTMoviemientos";

interface Props {
    idCliente: any,
    idCuenta: any
}

const useStyles = makeStyles((theme) => ({
    root: {
        fontSize: "14px"
    }
  }));

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: "rgb(127, 192, 244 , 0.4)",
        }
    },
}))(TableRow);

export default observer(function CCTMovimientos(props : Props) {
    const classes = useStyles();
    const nf = new Intl.NumberFormat("en-IN");
    const {CCTMovimientoStore} = useStore();
    const {loadCCTMovimiento, CCTMovimientoByCodigo, CCTMovimientoRegistry} = CCTMovimientoStore;

    useEffect(() => {
        if (props.idCliente) {
            loadCCTMovimiento(props.idCliente, props.idCuenta)
        }
    }, [props.idCliente, loadCCTMovimiento]);
  
    if (CCTMovimientoStore.loadingInitial) return <LoadingComponent content='Cargando datos..' />
    return (
        <>
            <h1>Detalle de Cuenta</h1>
            <TableContainer>
                <Table aria-label="a dense table" className={classes.root}>
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" className={classes.root}><b>Fecha</b></TableCell>
                            <TableCell align="center" className={classes.root}><b>Descripcion</b></TableCell>
                            <TableCell align="center" className={classes.root}><b>Cargo</b></TableCell>
                            <TableCell align="center" className={classes.root}><b>Abono</b></TableCell>
                            <TableCell align="center" className={classes.root}><b>Saldo actual</b></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {CCTMovimientoByCodigo.map((cuentas) =>{
                            var saldo_Actual = nf.format(cuentas.saldoActual)
                            var valor_cuenta = nf.format(cuentas.valor)
                            if((cuentas.saldoActual % 1) == 0){
                                saldo_Actual = saldo_Actual + ".00"
                            }
                            if((cuentas.valor % 1) == 0){
                                valor_cuenta = valor_cuenta + ".00"
                            }
                            if(cuentas.operacion == -1){
                                return(
                                    <StyledTableRow key={cuentas.id}>
                                        <TableCell component="th" scope="row" align="center" className={classes.root}>
                                            {cuentas.fecha}
                                        </TableCell>
                                        <TableCell align="left" className={classes.root}>{cuentas.descripcion}</TableCell>
                                        <TableCell align="center" className={classes.root}></TableCell>
                                        <TableCell align="center" className={classes.root}>{valor_cuenta}</TableCell>
                                        <TableCell align="right" className={classes.root}>{saldo_Actual}</TableCell>
                                    </StyledTableRow>
                                )
                            }else if(cuentas.operacion == 1){
                                return(
                                    <StyledTableRow key={cuentas.id}>
                                        <TableCell component="th" scope="row" align="center" className={classes.root}>
                                            {cuentas.fecha}
                                        </TableCell>
                                        <TableCell align="left" className={classes.root}>{cuentas.descripcion}</TableCell>
                                        <TableCell align="center" className={classes.root}>{valor_cuenta}</TableCell>
                                        <TableCell align="center" className={classes.root}></TableCell>
                                        <TableCell align="right" className={classes.root}>{saldo_Actual}</TableCell>
                                    </StyledTableRow>
                                )
                            }
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
})
